"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _ViewerAccountProviderQuery;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useAuth } from '@autoguru/auth';
import { storeGet, storePut } from '@autoguru/cache';
import { VIEWER_PREFERENCES_VERSION } from '@autoguru/global-configs';
import { invariant } from '@autoguru/utilities';
import { createContext, startTransition, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { useClientPreferences } from './useClientPreferences';
import { useDataDogUserIdentification } from './useDataDogUserIdentification';
import { jsx as _jsx } from "react/jsx-runtime";
const viewerAccountContext = /*#__PURE__*/createContext(null);
export const useViewerAccount = () => {
  const contextValue = useContext(viewerAccountContext);
  !(contextValue !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Please have a  <ViewerAccountProvider /> set in your tree') : invariant(false) : void 0;
  return contextValue;
};
export const useViewerPreferences = () => {
  const {
    clientPreferences,
    updateViewerPreferences
  } = useViewerAccount();
  return [clientPreferences || {}, updateViewerPreferences];
};
const ViewerAccountProviderInner = ({
  children
}) => {
  const {
    viewer
  } = useLazyLoadQuery(_ViewerAccountProviderQuery !== void 0 ? _ViewerAccountProviderQuery : _ViewerAccountProviderQuery = require("../../relay/__generated__/ViewerAccountProviderQuery.graphql"), {}, {
    fetchPolicy: 'store-or-network'
  });
  const [clientPersistedPreferences, setClientPersistedPreferences] = useState();

  // Localstorage cache key for this viewer
  const cacheKey = `${viewer.dbId}-v${VIEWER_PREFERENCES_VERSION}`;
  const clientPreferences = useClientPreferences({
    clientPersistedPreferences,
    clientPreferences: viewer.clientPreferences,
    viewerId: viewer.dbId.toString()
  });
  const updateViewerPreferences = useCallback(updates => {
    const mergedPrefs = _objectSpread(_objectSpread(_objectSpread({}, clientPreferences), updates), {}, {
      discardsBin: updates.discardsBin || clientPreferences.discardsBin
    });
    setClientPersistedPreferences(mergedPrefs);
    startTransition(() => {
      // Don't block while writing to localStorage
      storePut(cacheKey, mergedPrefs);
    });
  }, [clientPreferences]);
  useEffect(() => {
    const storedPrefs = storeGet(cacheKey);
    if (!(storedPrefs !== null && storedPrefs !== void 0 && storedPrefs.version) || storedPrefs.version < VIEWER_PREFERENCES_VERSION)
      // Missing or incompatible preferences version
      updateViewerPreferences({
        version: VIEWER_PREFERENCES_VERSION
      });else setClientPersistedPreferences(storedPrefs);
  }, [setClientPersistedPreferences, updateViewerPreferences]);
  useDataDogUserIdentification(viewer);
  return /*#__PURE__*/_jsx(viewerAccountContext.Provider, {
    value: useMemo(() => _objectSpread(_objectSpread({}, viewer), {}, {
      updateViewerPreferences,
      clientPreferences
    }), [viewer.dbId, updateViewerPreferences, clientPreferences]),
    children: clientPersistedPreferences ? children : null
  });
};
export const ViewerAccountProvider = ({
  children,
  skipAuthCheck: _skipAuthCheck = false
}) => {
  const {
    isAuthenticated
  } = useAuth();
  if (!_skipAuthCheck && !isAuthenticated) {
    return null;
  }
  return /*#__PURE__*/_jsx(ViewerAccountProviderInner, {
    children: children
  });
};